import { Box, MuiThemeProvider } from "@material-ui/core";
import { connect } from "react-redux";
import "./App.css";
import PageRoutes from "./routes/PageRoutes";
import { State } from "./redux/combinedReducer";
import { darkTheme, theme } from "./utils/global";
import Popup from "./components/Popup";
import { BrowserRouter } from "react-router-dom";
import Footer from "./components/Footer";
import CustomAppBar from "./components/CustomAppBar";
import { useState } from "react";
import { socialLinks } from "./utils/constants";

type Prop = {
  appTheme: string;
};
function App({ appTheme }: Prop) {
  const [colorChange, setColorchange] = useState(false);
  const changeNavbarColor = () => {
    if (window.scrollY >= 30) {
      setColorchange(true);
    } else {
      setColorchange(false);
    }
  };
  window.addEventListener("scroll", changeNavbarColor);
  return (
    <div className="App">
      <BrowserRouter>
        <MuiThemeProvider theme={appTheme === "dark" ? darkTheme : theme}>
          <Popup />
          <Box style={{ position: "relative" }}>
            <Box
              style={{
                position: "sticky",
                top: 0,
                zIndex: 10,
              }}
            >
              <CustomAppBar colorChange={colorChange} />
            </Box>
            <PageRoutes />
            <Footer
              email="promisestephen29@gmail.com"
              name="Promise Stephen"
              phoneNumber="08064453389"
              socialLink={socialLinks}
            />
          </Box>
        </MuiThemeProvider>
      </BrowserRouter>
    </div>
  );
}
const mapStateToProps = ({ app }: State) => ({
  appTheme: app.appTheme,
});

// eslint-disable-next-line
const mapDispatchToProps = ({}) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(App);
